import { useDispatch } from "react-redux";

import { EyeRegularV6 } from "@shared/v2/Icomoon";
import format from "@shared/formatters";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";
import Thumbnail from "./shared/Thumbnail";

const ViewedPropertyActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={EyeRegularV6}>
            3+ Listing Views
          </CategoryContainer>
        }
        personName={`${activity.data?.leadFirstName} ${activity.data?.leadLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={STYLES.contentContainer2}>
        <div className={`${STYLES.contentContainer} tw-text-14d`}>
          <DataField
            label="Address"
            data={[
              activity.data?.propertyStreetAddress,
              activity.data?.propertyCity,
              activity.data?.propertyState,
              activity.data?.propertyZip,
            ]
              .filter(Boolean)
              .join(", ")}
          />
          <DataField label="Price" data={format.currency(activity.data?.propertyPrice, 0)} />
          <ActivityBtns
            callHandlr={() => {
              if (activity.personUuid) {
                dispatch(
                  setCallParams({ leadUuids: [activity.personUuid], callSource: "Viewed Property Activity" }),
                );
              }
            }}
            listingHandlr={
              activity.data?.propertyDetailsUrl
                ? () => {
                    window.open(activity.data?.propertyDetailsUrl, "_blank");
                  }
                : null
            }
          />
        </div>
        {activity.imageUrl && <Thumbnail src={activity.imageUrl} />}
      </div>
    </ActivityContainer>
  );
};

export default ViewedPropertyActivity;

ViewedPropertyActivity.propTypes = {
  ...activityCommonPropTypes,
};

ViewedPropertyActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
